module.exports = __webpack_public_path__ + "static/media/verifyIcon.34843b40.svg";